$w.onReady(async function () {

    let isUserMember = await getUserClient()
    console.log({ isUserMember }, "here")
    if (isUserMember.errorCode == 0) {
        //member
        $w('#button70').label = 'Otimizar a acessibilidade do seu site >';
        $w('#button69').label = 'Acessar o Assistente de Acessibilidade'
        $w('#button636').label = 'Crie um site acessível a todos'
        $w('#button64').label = 'Acessar o Assistente de Acessibilidade'
    }

});

export function getUserClient() {

    return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
        method: 'GET',
        credentials: 'include', //passes cookie
        cache: 'no-store', //disables cache
    }).then((result) => {
        if (result.ok) {
            console.log({ result })
            return result.json()
        }
    }).catch((err) => {
        return { err }
    })

}